import { Component, HostBinding, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'vnm-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss']
})
export class GridComponent {
  @HostBinding('attr.style') get valuesAsStyle() {
    const styleVars = `
      --grid-column-max: ${this.colMax};
      --grid-column-min: ${this.colMin};
      --grid-gap: ${this.gap};
    `;
    return this.sanitizer.bypassSecurityTrustStyle(styleVars);
  }

  @Input() colMax = '25rem';
  @Input() colMin = '16rem';
  @Input() gap = '1em';

  constructor(private sanitizer: DomSanitizer) {}
}
